<template>
    <BasePanel 
        headline="lang_PUBLISHING_WORKS_DISTRIBUTION_PANEL_CAPTION_DISTRIBUTION"
        :alvqa="alvqa"
    >
        <template v-slot:panelContent>
            <v-data-table         
                :headers="headers"
                hide-default-footer
                :items="item"
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                class="noMinWidth"
                :items-per-page="itemsPerPage"
            >
                <!-- alvqas for headers -->
                <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                    <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                </template>

                <template v-slot:[`item.code_name`]="{ item }">
                    <div :alvqa="alvqa +'-text-code-name'">
                        {{ getCodeName(item) }}
                    </div>
                </template>

                <template v-slot:[`item.function`]="{ item }">
                    <div :alvqa="alvqa +'-text-function'">
                        {{ getFunction(item.function) }}
                    </div>
                </template>

                <template v-slot:[`item.data`]="{ item }">
                    <div :alvqa="alvqa +'-text-data'">
                        {{ item.data }}
                    </div>
                </template>
                
                <template v-slot:[`item.status`]="{ item }">
                    <div :alvqa="alvqa +'-text-status'">
                        {{ getStatus(item.status) }}
                    </div>
                </template>

                <template v-slot:[`item.distribution_time`]="{ item }">
                    <div :alvqa="alvqa +'-text-distribution-time'">
                        {{ $d(new Date(item.distribution_time), 'alvDateTime') }}
                    </div>
                </template>

                <template v-slot:[`item.notes`]="{ item }">
                    <div class="ellipsis">
                        <BaseTooltip>
                            <template v-slot:content><span>{{ $t(item.notes) }}</span></template>
                            <template v-slot:text><span>{{ $t(item.notes) }}</span></template>
                        </BaseTooltip>
                    </div>
                </template>

                <template v-slot:[`item.download_path`]="{ item }">
                    <BaseIcon
                        @click.stop="downloadFile(item.download_path)" 
                        icon="cloud_download" 
                        :tooltipText="distributionDownloadTooltip(item)" 
                        :alvqa="alvqa + '-icon-download-file-distribution'"
                        style="vertical-align: middle;"
                        v-if="'download_path' in item && item.download_path !== null" 
                    />
                    <BaseIcon
                        v-if="canPreviewDistributionFile(item)"
                        @click.stop="previewFile(item.download_path)"
                        icon="visibility"
                        :tooltipText="$t('lang_GENERAL_BUTTON_PREVIEW_CWR')"
                        :alvqa="alvqa + '-icon-preview-file-distribution'"
                        style="vertical-align: middle;"
                    />
                </template>

            </v-data-table>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'
import BaseTooltip from '@/components/_base/BaseTooltip'
import BaseIcon from '@/components/_buttons/BaseIcon'

import api from '@/api_alv'
import { isCwrPreviewableFile, openAckPreview } from '@/assets/helpers/cwrPlayground.js'

export default {
    name: "WorkDistributionsPanel",
    components: {
        BasePanel,
        BaseTooltip,
        BaseIcon
    },
    props:{
        workAlvId: {
            type: String
        }
    },
    data() {
        return {
            alvqa: 'publishing-works-list-row-' + this.workAlvId + '-read-only-panel-distributions'
        }
    },
    computed: {
        item() {
            let item = this.$store.getters.getExpandedWorks.find(element => {                
                return element.alvId === this.workAlvId
            }) 
            
            let distributions = item.distributions === null ? [] : item.distributions
            return distributions
        },
        headers() {
            return [
                {
                    text: this.$t("lang_PUBLISHING_WORKS_DISTRIBUTION_PANEL_CAPTION_TARGET"), 
                    align: "left", 
                    value: "code_name",
                    sortable: false,
                    alvqa: this.alvqa + '-header-target'
                },
                {
                    text: this.$t("lang_PUBLISHING_WORKS_DISTRIBUTION_PANEL_CAPTION_FUNCTION"), 
                    align: "left", 
                    value: "function",
                    sortable: false,
                    alvqa: this.alvqa + '-header-function'
                },
                {
                    text: this.$t("lang_PUBLISHING_WORKS_DISTRIBUTION_PANEL_CAPTION_DATA"), 
                    align: "left", 
                    value: "data",
                    sortable: false,
                    alvqa: this.alvqa + '-header-data'
                },
                {
                    text: this.$t("lang_PUBLISHING_WORKS_DISTRIBUTION_PANEL_CAPTION_STATUS"), 
                    align: "left", 
                    value: "status",
                    sortable: false,
                    alvqa: this.alvqa + '-header-status'
                },
                {
                    text: this.$t("lang_PUBLISHING_WORKS_DISTRIBUTION_PANEL_CAPTION_DATE"), 
                    align: "left", 
                    value: "distribution_time",
                    sortable: false,
                    alvqa: this.alvqa + '-header-date'
                },
                {
                    text: this.$t("lang_GENERIC_CAPTION_NOTES"), 
                    align: "left", 
                    value: "notes",
                    sortable: false,
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + '-header-notes'
                },
                {
                    text: this.$t("lang_GENERIC_CAPTION_ACTIONS"),
                    align: "left",
                    value: "download_path",
                    sortable: false,
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + '-header-download'
                }
            ]
        },
        itemsPerPage() { return this.$store.getters.getItemsPerPage },
    },
    methods: {
        getStatus(status) {
            switch (status) {
                case 'sent':
                    return this.$t('lang_GENERIC_CAPTION_SENT')
                    break;
                case 'submitted':
                    return this.$t('lang_GENERIC_CAPTION_SUBMITTED')
                    break;
                case 'registered':
                    return this.$t('lang_GENERIC_CAPTION_REGISTERED')
                    break;
                case 'rejected':
                    return this.$t('lang_GENERIC_CAPTION_REJECTED')
                    break;
                case 'error':
                    return this.$t('lang_GENERIC_CAPTION_ERROR')
                    break;
                case 'success':
                    return this.$t('lang_GENERIC_CAPTION_SUCCESSFUL')
                    break;
                case 'done':
                    return this.$t('lang_GENERIC_CAPTIONS_DONE')
                    break;
                case 'created':
                    return this.$t('lang_GENERIC_CAPTION_CREATED')
                    break;
                case 'updated':
                    return this.$t('lang_GENERIC_CAPTION_UPDATED')
                    break
                default:
                    return''
                    break
            }
        },
        getFunction(value) {
            switch (value) {
                case 'gema-soundfile':
                    return this.$t('lang_GENERIC_CAPTION_SOUNDFILE')
                    break;
                case 'work-registration':
                    return this.$t('lang_GENERIC_CAPTION_WORK_REGISTRATION')
                    break;
                case 'work-import-cwr':
                    return this.$t('lang_GENERIC_CAPTION_MANUAL_IMPORT')
                    break;
                case 'mapping-import':
                    return this.$t('lang_GENERIC_CAPTION_MAPPING_IMPORT')
                    break;
                default:
                    return''
                    break
            }
        },
        getCodeName(item) {
            if (item.code_name) {
                return item.code_name
            }

            if (item.az_name) {
                return item.az_name
            }

            return ''
        },
        distributionDownloadTooltip(row) {
            const base = this.$t('lang_GENERAL_CAPTION_ICON_DOWNLOAD')
            const raw = row.file_name || row.fileName
            if (!raw || String(raw).trim() === '') {
                return base
            }
            return base + ' (' + this.distributionFileDisplayName(raw) + ')'
        },
        distributionFileDisplayName(pathOrName) {
            const s = String(pathOrName).trim()
            const parts = s.split(/[/\\]/)
            return parts[parts.length - 1] || s
        },
        canPreviewDistributionFile(item) {
            if (!('download_path' in item) || item.download_path === null) return false
            const name = item.file_name || item.fileName || item.download_path
            return isCwrPreviewableFile(name)
        },
        downloadFile(download_path) {
            if (download_path === null) {
                return;
            }

            api.getFileFromALV(download_path)
            this.$store.commit('setSnackbar', {
                type: 'success',
                msg: this.$t('lang_GENERAL_SNACKBAR_DOWNLOAD_SUCCESSFULL')
            })
        },
        previewFile(download_path) {
            openAckPreview(download_path)
        }
    },
}
</script>

<style>
    .noMinWidth table {
        min-width: 0px !important;
    }
</style>